import { render, staticRenderFns } from "./APIKey.vue?vue&type=template&id=47585dbc&scoped=true&"
import script from "./APIKey.vue?vue&type=script&lang=js&"
export * from "./APIKey.vue?vue&type=script&lang=js&"
import style0 from "./APIKey.vue?vue&type=style&index=0&id=47585dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47585dbc",
  null
  
)

export default component.exports